import React, { useContext, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import { DataTypeContext } from '../../DataTypes';
import { AccountContext } from '../../Accounts';
import CreateAccountFormStep1 from './CreateAccountFormStep1';
import CreateAccountFormStep2 from './CreateAccountFormStep2';

const CreateAccount = ({ step = 1 }) => {
    const { username, logout } = useContext(AccountContext);
    const { dataTypes } = useContext(DataTypeContext);
    const isFirstStep = step === 1;

    // eslint-disable-next-line
    useEffect(() => { logout() }, []);

    return (
        <>
            {isFirstStep || (!isFirstStep && username) ? (
                <Col md={6} sm={12} className="mx-auto card shadow-sm rounded p-4">
                    {isFirstStep ? <CreateAccountFormStep1 /> : <CreateAccountFormStep2 />}
                </Col>
            ) : (
                <Redirect to={{ pathname: '/' }} />
            )}
        </>
    );
};

export default CreateAccount;
